module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Sieve-156189d14ca89484804ec22fb281847f.svg";